import React, { PropsWithChildren, useEffect, useState } from 'react';
import { InstagramEmbed } from 'react-social-media-embed';


/**
 * @interface IEmbedInstagramProps declares any input properties required for this component.
 */
export interface IEmbedInstagramProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedInstagram is a React functional component for displaying a Instagram social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedInstagram: React.FC<IEmbedInstagramProps> = (props: IEmbedInstagramProps) => {
  EmbedInstagram.displayName = 'EmbedInstagram';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedInstagram. Entered EmbedInstagram`);

  const { url, postWidth, postHeight } = props;


  // The script that the react-social-media-embed component uses to load and embed Instagram posts is apparently out of date. We will load an
  // updated Instagram embed script (see https://github.com/justinmahar/react-social-media-embed/issues/53)
  useEffect(() => {
    const script = document.createElement("script");
    // script.src = 'https://www.instagram.com/embed.js';
    script.src = "https://www.instagram.com/static/bundles/metro/EmbedSDK.js/d9addf525b6a.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <InstagramEmbed url={url} width={postWidth} height={postHeight} />
    </>
  )
}
